import {
    InfoHint,
    InfoHintBody,
    InfoHintContent,
    InfoHintHeader,
    InfoHintTitle,
    InfoHintTrigger,
} from '@plato/ui/components/info-hint';
import { keepPreviousData } from '@tanstack/react-query';
import { isEmpty } from 'lodash-es';
import { useLocale } from '../../../lib/hooks/use-locale.ts';
import { api } from '../../../utils/api.ts';
import { useExplorerView } from './use-explorer-query-params.ts';

export function useExplorerTotalSummary() {
    const { t } = useLocale('explorer');

    // We need to validate if the user applied any filters
    const { filters, state, combinedFilters } = useExplorerView();

    const { window, billingStatus, customDateRange } = state;
    const hasFilters = Object.keys(filters).some((key) => !isEmpty(filters[key as keyof typeof filters]));

    const { data, isLoading } = api.platoUser.query.explorer.getExplorerSummary.getTotalWithFilters.useQuery(
        {
            filters: combinedFilters,
            window,
            billingStatus,
            customDateRange,
        },
        {
            enabled: hasFilters,
            placeholderData: hasFilters ? keepPreviousData : undefined,
        },
    );

    if (isLoading || !data || !hasFilters) {
        return {};
    }

    return {
        summaryHeader: {
            name: (
                <div className="flex items-center gap-1">
                    {t('total_summary__name')}
                    <InfoHint>
                        <InfoHintTrigger />
                        <InfoHintContent side="right">
                            <InfoHintHeader>
                                <InfoHintTitle>{t('total_summary__name')}</InfoHintTitle>
                            </InfoHintHeader>
                            <InfoHintBody>{t('total_summary__name_tooltip')}</InfoHintBody>
                        </InfoHintContent>
                    </InfoHint>
                </div>
            ),
            ...data,
        },
    };
}
